const SENSITIVE_KEYS = [
  "password",
  "confirm_password",
  "old_password",
  "new_password",
  "token",
  "access_token",
  "refresh_token",
  "authorization",
  "otp",
  "secret",
  "api_key",
  "apikey",
];

const isSensitiveKey = (key: string) =>
  SENSITIVE_KEYS.some((k) => key.toLowerCase().includes(k));

/**
 * Recursively strips known-sensitive fields before anything leaves the
 * browser. Applied to every log event's `details` payload.
 */
export const redact = (value: any, depth = 0): any => {
  if (depth > 5 || value == null) return value;

  if (Array.isArray(value)) {
    return value.map((item) => redact(item, depth + 1));
  }

  if (typeof value === "object") {
    const result: Record<string, any> = {};
    for (const key of Object.keys(value)) {
      result[key] = isSensitiveKey(key)
        ? "[REDACTED]"
        : redact(value[key], depth + 1);
    }
    return result;
  }

  return value;
};
